define(function (require) {
    'use strict';

    var $ = require('jquery');
    var Backbone = require('backbone');
    var EasyDialog = require('easyDialog');
    var DateTZ = require('tzdate');

    var notificationListener = require('common/NotificationListener');
    var notification_template = require('common/templates/notifications/LiveClassFeedbackNotificationWrapper.html');
    var html_template = require('common/templates/LiveClassFeedback.html');

    var wrapper_template = _.template(notification_template);
    var feedback_template = _.template(html_template);
    var template = wrapper_template({feedback: feedback_template});

    return Backbone.View.extend({

        initialize: function () {
            this.notification = this.options.notification;
            this.model.on("sync", this.render, this);
            this.on("LiveClassFeedbackNotificationReady", this.show, this);
            this.isNotificationReady = false;
            this.model.fetch();
        },

        onClose: function (event) {
            $.easydialog.close('feed-back');
        },

        render: function () {
            var data = this._prepareData(this.model.attributes);
            if(this.model && this.model.attributes && this.model.attributes.teacherId ) {
                this.$el.html(wrapper_template({feedback: feedback_template(data)}));

                if(!this.isNotificationReady) {
                    this.isNotificationReady = true;
                    this.trigger("LiveClassFeedbackNotificationReady");
                }
            }
            return this;
        },

        show: function () {
            var me = this;
            if(!this.isNotificationReady) {
                return;
            }

            notificationListener.confirm(me.notification);

            $.easydialog({
                container: 'feed-back',
                content: $('#feed-back'),
                closeOnEscape: false,
                onStart: function () {
                    me.$popup = $('#feed-back');
                    me.$popup.find('.btn-close').on('click', function (event) {
                        me.onClose(event);
                    });
                },
                onCleanup: function () {
                    if (me._isGlobalNotification(me.notification)) {
                        notificationListener.deleteNotification(me.notification);
                    }

                    me.remove();
                }
            });
        },

        _isGlobalNotification: function(notification) {
            return !notification.personId;
        },

        _prepareData: function (data) {

            data = Object.assign(data, {
                title: this.notification.title,
                notification: this.notification.notification,
                i18n: i18n,
                i18nPage: i18n.liveReminder
            });
            return data;
        }
    });
});



//////////////////
// WEBPACK FOOTER
// ./js/common/views/notifications/LiveClassFeedbackPopUpNotification.js
// module id = 1129
// module chunks = 27 28 29